import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'

import Chart from '../../components/Chart'
import Table from '../../components/Table'

import { defineYTicks } from '../../core/helpers/ChartHelpers'
import ChartDataset from '../../core/models/ChartDataset'
import AllSubjectsTable from '../../core/models/AllSubjectsTable'

import * as socketService from '../../core/services/socketService'

import style from './style.module.css'
import SideBar from '../../components/SideBar'

class NocSubjects extends Component {
  state = {
    topChartData: {},
    allSubjectTableData: [],
    shouldUpdateInfo: false
  }

  componentDidMount() {
    const { enterSocketChannel } = socketService
    const { selectedView } = this.props
    this._isMounted = true

    if (selectedView) {
      enterSocketChannel('nocSubjects', [selectedView.name])
    }
  }

  componentDidUpdate(prevProps) {
    const { disconectSocketChannel, enterSocketChannel } = socketService
    const { socketInformationTrigger, selectedView } = this.props

    if (
      prevProps.selectedView &&
      selectedView &&
      prevProps.selectedView.name !== selectedView.name
    ) {
      disconectSocketChannel('nocSubjects', [prevProps.selectedView.name])
      enterSocketChannel('nocSubjects', [selectedView.name])
    }

    if (prevProps.socketInformationTrigger !== socketInformationTrigger) {
      this.updateDashboard()
    }
  }

  componentWillUnmount() {
    const { disconectSocketChannel } = socketService
    const { selectedView } = this.props
    this._isMounted = false

    if (selectedView) {
      disconectSocketChannel('nocSubjects', [selectedView.name])
    }
  }

  updateDashboard = () => {
    const { socketInformation } = socketService

    if (socketInformation && socketInformation.nocSubjects) {
      const allSubjectTableData = socketInformation.nocSubjects['top_300'].map(
        subject => new AllSubjectsTable(subject)
      )
      const topChartData = new ChartDataset(socketInformation.nocSubjects['top_5'], 'noc-subjects')

      this._isMounted &&
        this.setState({ topChartData, allSubjectTableData, shouldUpdateInfo: true })
    }
  }

  render = () => {
    const { topChartData, allSubjectTableData, shouldUpdateInfo } = this.state

    return (
      <>
        <SideBar />

        <div id="noc-subjects">
          <div className={style['noc-subjects-chart--table']}>
            <Chart
              id="nocSubjects"
              data={topChartData}
              type="bar"
              title="Top 5 Desvios Preocupantes"
              height="75vh"
              width="75%"
              extraYScales={{
                ticks: defineYTicks(topChartData, 4),
                spanGaps: false,
                gridLines: {
                  display: false
                },
                id: 'noc-subjects-percent',
                type: 'linear',
                position: 'right'
              }}
              shouldUpdateInfo={shouldUpdateInfo}
              handShakeFn={() => this.setState({ shouldUpdateInfo: false })}
            />
          </div>
          <Table
            data={allSubjectTableData}
            pageSize={10}
            tableTitle="Todos os Assuntos"
            tableClassName="table-full"
            defaultSortedId="d0"
            headers={[
              {
                headerText: 'Assunto',
                accessor: 'subject',
                width: 700
              },
              {
                headerText: 'D-21',
                accessor: 'd21'
              },
              {
                headerText: 'D-14',
                accessor: 'd14'
              },
              {
                headerText: 'D-7',
                accessor: 'd7'
              },
              {
                headerText: 'D-0',
                accessor: 'd0'
              },
              {
                headerText: 'Média',
                accessor: 'weeklyAverage'
              },
              {
                headerText: 'Desvio',
                accessor: 'deviation'
              },
              {
                headerText: 'Preocupante',
                accessor: 'isWorrying'
              }
            ]}
          />
        </div>
      </>
    )
  }
}

const mapStateToProps = state => ({ ...state.sideBarReducer, ...state.globalReducer })

export default connect(mapStateToProps)(withRouter(NocSubjects))
